import Link from 'next/link'
import router from 'next/router'
import logoNav from '../../public/assets/images/logo.svg'
import logoFooter from '../../public/assets/images/logoBranco.svg'

type Props = {
  logo: string
  alt: string
}

const Logo = ({ logo, alt }: Props) => {
  return (
    <div className="flex items-center">
      {logo == 'nav' ? <img src={logoNav} alt={alt} /> : <a onClick={() => {
        router.push({
          pathname: '/',
        })
      }}><img src={logoFooter} alt={alt} /></a>}
    </div >
  )
}

export default Logo